import AttachmentInfo from './store/schema/AttachmentInfo';
import AttachmentModel, { ReferenceAttachmentModel } from './store/schema/AttachmentModel';
import SmimeAttachmentType from './store/schema/SmimeAttachmentType';
import { AttachmentConstants } from './utils/attachmentConstants';
import { default as isSmimeAttachmentType, isSmimeAttachment } from './utils/isSmimeAttachmentType';
import { default as getTypeOfAttachment } from './utils/getTypeOfAttachment';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CheckPendingAttachmentOperationResponse from 'owa-service/lib/contract/CheckPendingAttachmentOperationResponse';
import AttachmentInitializationParameters, {
    AttachmentModelPropertyValues,
} from './store/schema/AttachmentInitializationParameters';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentModelStore", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded actions
export const lazyAddAndInitializeAttachments = new LazyAction(
    lazyModule,
    m => m.addAndInitializeAttachments
);

export const lazySetPreviewImageUrl = new LazyAction(lazyModule, m => m.setPreviewImageUrl);
export const lazyRefreshDownloadUrl = new LazyAction(lazyModule, m => m.refreshDownloadUrl);
export const lazyCreateAttachmentInfo = new LazyAction(lazyModule, m => m.createAttachmentInfo);
export const lazySetAttachmentInfo = new LazyAction(lazyModule, m => m.setAttachmentInfo);

export const lazyRefreshThumbnailImageUrl = new LazyAction(
    lazyModule,
    m => m.refreshThumbnailImageUrl
);

export const lazyRefreshPreviewImageUrl = new LazyAction(lazyModule, m => m.refreshPreviewImageUrl);

// Delay loaded imports
export const lazyGetAttachment = new LazyImport(lazyModule, m => m.getAttachment);

export const lazyCheckPendingAttachmentOperation = new LazyImport(
    lazyModule,
    m => m.checkPendingAttachmentOperation
);

export const lazyShouldShowImageView = new LazyImport(lazyModule, m => m.shouldShowImageView);

// SatchelV3 actions:
export { refreshSharingTipsForAttachment } from './actions/satchelV3Actions/publicActions';

export { default as AttachmentClass } from './store/schema/AttachmentClass';
export { default as UrlInfo } from './store/schema/UrlInfo';
export { default as AttachmentUrlType } from 'owa-files-url/lib/schema/AttachmentUrlType';
export {
    default as AttachmentOperationType,
} from 'owa-service/lib/contract/AttachmentOperationType';

export {
    AttachmentConstants,
    AttachmentModel,
    AttachmentModelPropertyValues,
    AttachmentInfo,
    AttachmentType,
    SmimeAttachmentType,
    AttachmentInitializationParameters,
    isSmimeAttachmentType,
    isSmimeAttachment,
    CheckPendingAttachmentOperationResponse,
    ClientAttachmentId,
    ClientItemId,
    ReferenceAttachmentModel,
    getTypeOfAttachment,
};
export { default as attachmentStore } from './store/store';
export { default as TypeOfAttachment } from './store/schema/TypeOfAttachment';
